const MB_IN_BYTES = 1024 * 1024;
const calculateFileSizeMB = (file: Pick<File, 'size'>): number =>
  file.size / MB_IN_BYTES;

export const calculateTotalFileSizeMB = (
  files: Pick<File, 'size'>[],
): number => {
  if (!files) {
    return 0;
  }

  return files.reduce((total: number, file: Pick<File, 'size'>) => {
    return total + calculateFileSizeMB(file);
  }, 0);
};

export const getFilenameFromContentDisposition = (
  contentDisposition: string | null,
  fallbackFilename: string,
): string => {
  if (!contentDisposition) {
    return fallbackFilename;
  }

  // Handle both filename="..." and filename*=UTF-8''... formats
  const filenameMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
    contentDisposition,
  );
  if (!filenameMatch?.[1]) {
    return fallbackFilename;
  }

  // Remove quotes if present
  let filename = filenameMatch[1].replace(/['"]/g, '');
  // Handle RFC 5987 encoded filenames (filename*=UTF-8''...)
  if (filename.startsWith("UTF-8''")) {
    filename = decodeURIComponent(filename.substring(7));
  }

  return filename;
};
